import TabToggleList from 'components/commons/tab-toogle-list'
import { Button, InlineError, Input } from 'avo-ui'
import icAddSquare from 'assets/images/ic-add-square.svg'
import TabToggle from 'components/commons/tab-toogle'
import Select from 'components/commons/select'

export const Promo = ({
    dataPromo,
    items,
    setItems,
    onChangeItem,
    onChangePromo,
    onAddNewItem,
    optionsType,
    errorForm,
}) => {
    const getError = (key, index) => {
        const findError = errorForm?.promo_data?.promos_detail?.find((i) => i?.index === index && i?.key === key)
        return findError?.message
    }

    return (
        <TabToggle
            title={'Promo'}
            content={
                <div className={'flex flex-col space-y-5'}>
                    <div className={'w-1/2 flex flex-col space-y-3'}>
                        <div className={'font-semibold text-blue-90 required'}>Title Section</div>
                        <Input
                            className={'flex-1'}
                            name={'section_title'}
                            placeholder={'Masukkan title section'}
                            value={dataPromo?.section_title}
                            onChange={(item) => onChangePromo({ [item?.name]: item?.value })}
                        />
                        <InlineError className='mt-2' message={errorForm?.promo_data?.section_title} />
                    </div>
                    {items?.map((item, index) => (
                        <TabToggleList
                            key={`promo-${index}`}
                            index={index}
                            title={`Promo-Item-${index + 1}`}
                            content={
                                <div className={'flex space-x-16'}>
                                    <div className={'flex-1 flex-col space-y-5'}>
                                        <div className={'flex flex-col space-y-3'}>
                                            <div className={'font-semibold text-blue-90 required'}>Type Promo</div>
                                            <Select
                                                name={'type'}
                                                className={'flex-1'}
                                                optionsClassName={'max-h-40'}
                                                placeholder={'Pilih tipe promo'}
                                                options={optionsType}
                                                value={item?.type}
                                                onChange={(item) => onChangeItem({ ...item, index })}
                                            />
                                            <InlineError className='mt-2' message={getError('type', index)} />
                                        </div>
                                        <div className={'flex flex-col space-y-3'}>
                                            <div className={'font-semibold text-blue-90 required'}>Link URL Promo</div>
                                            <Input
                                                className={'flex-1'}
                                                name={'url'}
                                                placeholder={'Masukkan link url promo'}
                                                value={item?.url}
                                                onChange={(item) => onChangeItem({ ...item, index })}
                                            />
                                            <InlineError className='mt-2' message={getError('url', index)} />
                                        </div>
                                    </div>
                                    <div className={'flex-1 space-y-3'}>
                                        <div className={'font-semibold text-blue-90 required'}>Title Promo</div>
                                        <Input
                                            type={'text-area'}
                                            className={'flex-1'}
                                            name={'title'}
                                            placeholder={'Masukkan title promo'}
                                            value={item?.title}
                                            row={5}
                                            onChange={(item) => onChangeItem({ ...item, index })}
                                        />
                                        <InlineError className='mt-2' message={getError('title', index)} />
                                    </div>
                                </div>
                            }
                            items={items}
                            setItems={setItems}
                            isDisableDelete={items?.length === 1}
                            isSorting
                        />
                    ))}
                    <InlineError className='mt-2' message={errorForm?.promo_data?.promos} />
                    <Button
                        className={'w-fit'}
                        type={'outline'}
                        icon={icAddSquare}
                        title={'Add New Item'}
                        onClick={onAddNewItem}
                    />
                </div>
            }
        />
    )
}
